// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetMemberProfileResponse

export type WidgetMemberProfileApiResponse = {
	firstName: string;
	lastName: string;
	email: string;
	phone: string;
};

export type WidgetMemberProfile = {
	firstName: string;
	lastName: string;
	email: string;
	phone: string;
};

export function hydrateWidgetMemberProfile(data: WidgetMemberProfileApiResponse): WidgetMemberProfile {
	return { ...data };
}